export function match(param: string) {
	return /^\d{2}$/.test(param);
}
